export default __webpack_public_path__ + "static/media/deskcoach-dark.9c1c552d.svg";